import { CaretakerApiService } from '@/services/CaretakerAPIService'
import TokenService from '@/services/TokenService'

/**
 * CMS pages require a caretaker Bearer token. Authenticate first (Sanctum + token),
 * then request the page — same flow as the legacy web app.
 */
export default {
  async getPage(id) {
    await TokenService.getAccessToken('caretaker')
    return CaretakerApiService.get(`/api/cms/page/${encodeURIComponent(id)}`)
  },
}
